/*    
<summary>
  This functional component "ConfirmPopupHOC" provides props to the child component.
  1. State "showConfirmPopup" that manages the show/hide of pop up
  2. Function "ConfirmPopupToggleHandler" to toggle the show/hide popup state "showConfirmPopup"
  Developer:Aashish Singh, Created Date:02-April-2024
</summary>
<returns>Returns JSX</returns>
*/

import React, {useState } from 'react';

const ConfirmPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showConfirmPopup,setShowConfirmPopup] = useState<boolean>(false);

    const confirmToggleHandler = () => {
        setShowConfirmPopup(!showConfirmPopup);
    }
	
	return <Component showConfirmPopup={showConfirmPopup} confirmToggleHandler={confirmToggleHandler} {...props}/>;
};

export default ConfirmPopupHOC;   